import { useEffect, useRef } from 'react';
import useForceUpdate from '../../../hooks/useForceUpdate';
import { usePreviousValue } from '../../../hooks/usePreviousValue';
// Currently used only by GlobalSettingsProvider and the correct value is then made available to
// all descendants through useSettingsService hook backed by a context. This is done so that
// we do not make un-necessary authorization service calls to detect the write access.
export function useHasSettingsWriteAccess(dataProvider) {
  const forceUpdate = useForceUpdate();
  const isPending = useRef(true);
  const hasWriteAccess = useRef(true);
  const prevDataProvider = usePreviousValue(dataProvider);
  if (prevDataProvider !== dataProvider) {
    isPending.current = true;
    hasWriteAccess.current = true;
  }
  useEffect(() => {
    let mounted = true;
    async function invokeHasWriteAccess() {
      try {
        const result = await dataProvider.hasWriteAccess();
        if (mounted) {
          isPending.current = false;
          hasWriteAccess.current = result;
          forceUpdate();
        }
      } catch (e) {
        if (mounted) {
          isPending.current = false;
          hasWriteAccess.current = true;
          forceUpdate();
        }
      }
    }
    invokeHasWriteAccess();
    return () => {
      mounted = false;
    };
  }, [dataProvider, forceUpdate]);
  return {
    isWriteAccessDetectionPending: isPending.current,
    hasWriteAccess: hasWriteAccess.current
  };
}
//# sourceMappingURL=useHasSettingsWriteAccess.js.map